import React, { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { useProductStore } from '../../../../ProductProvider';

interface Props {}

const F: React.FC<Props> = ({}) => {
    const { t } = useLang('theProductV2.F');
    const [load, setLoad] = useState(false);
    const [enter, setEnter] = useState(false);
    const { productInfo } = useProductStore();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scenes: any[] = [];
            scenes.push(
                AniContainer.create({
                    triggerElement: '.PowerSolution',
                    triggerHook: 1,
                    onEnter: () => setLoad(true),
                }),
            );
            scenes.push(
                AniContainer.create({
                    triggerElement: '.rapid-mag-F .card1 .bars',
                    triggerHook: 1,
                    offset: 100,
                    duration: '120%',
                    onEnter: () => setEnter(true),
                    onLeave: () => setEnter(false),
                }),
            );
            if (window.innerWidth > 1024) {
                scenes.push(
                    AniContainer.create({
                        triggerElement: '.rapid-mag-F',
                        triggerHook: 1,
                        offset: '90%', //根据设计稿调整 //过大或过小会导致锁屏出现浮层
                        duration: '8%', //duration越大，动画慢，会出现分层
                        syncFromTo: [
                            ['.rapid-mag-F .card1', { opacity: 1 }, { opacity: 0 }],
                            ['.rapid-mag-F .card2', { opacity: 0 }, { opacity: 1 }],
                        ],
                    }),
                );
            }
            return () => scenes.forEach((scene) => scene.destroy());
        }
    }, [productInfo]);


  // 控制 charging
    const [chargingBar, setChargingBar] = useState(false);
    useEffect(() => {
        const charging = document.querySelector('.rapid-mag-F .card1 .charging-speed');
        if (!charging) return;
        
        const callback = (entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setChargingBar(true);
                }
            });
        };
        
        const observer = new IntersectionObserver(callback, {
            threshold: 0.5, // 当元素50%进入视口时触发
        });
        
        observer.observe(charging);
        
        return () => {
            observer.disconnect();
        };
    }, []);

     const speeds = [
        {
            name: t('1_bar1_text1'),
            minutes: t('1_bar1_text2'),
            width: '45%',
            color: '#63FF78',
        },
        {
            name: t('1_bar2_text1'),
            minutes: t('1_bar2_text2'),
            width: '70%',
            color: 'linear-gradient(90deg, #DCDCDC 0%, #B6B6B6 100%)',
        },
    ];

    return (
        <section
            id="rapid-mag-F"
            className={`rapid-mag-F ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-F'}
            data-section-title={t('title')}
        >
            <div className="box-pc">
                <div className="sticky">
                    <div className="card card1">
                        <div className="video">
                            {load && (
                                <video
                                    src="https://websiteoss.ecoflow.com/upload/video/1764744845761/f1.mp4"
                                    muted
                                    autoPlay
                                    loop
                                    width="100%"
                                    height="100%"
                                    playsInline
                                    poster=""
                                    preload="auto"
                                />
                            )}
                        </div>
                        <div className="info">
                            <div className="icon">
                                <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479852687-ibq55f-compressed-Frame%201000009055.jpg" isOpenLazy/>
                            </div>
                            <p className="title">{t('1_title')}</p>
                            <p className="desc">{t('1_desc')}</p>
                            <div className={`bars${enter ? ' enter' : ''}`}>
                                <div className="bar bar1">
                                    <span className="text1">{t('1_bar1_text1')}</span>
                                    <p className="line"></p>
                                    <span className="text2">{t('1_bar1_text2')}</span>
                                </div>
                                <div className="bar bar2">
                                    <span className="text1">{t('1_bar2_text1')}</span>
                                    <p className="line"></p>
                                    <span className="text2">{t('1_bar2_text2')}</span>
                                </div>
                            </div>
                            <p className="desc">{t('1_tip')}</p>
                        </div>
                    </div>
                    <div className="card card2">
                        <div className="video">
                            {load && (
                                <video
                                    src="https://websiteoss.ecoflow.com/upload/video/1764744845827/f2.mp4"
                                    muted
                                    autoPlay
                                    loop
                                    width="100%"
                                    height="100%"
                                    playsInline
                                    poster=""
                                    preload="auto"
                                />
                            )}
                        </div>
                        <div className="info">
                            <div className="icon">
                                <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479852687-ibq55f-compressed-Frame%201000009055.jpg" isOpenLazy={true}/>
                            </div>
                            <p className="title">{t('2_title')}</p>
                            <p className="desc">{t('2_desc')}</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* H5 */}
            <div className="box-h5">
                <div className="sticky">
                    <div className="card card1">
                        <div className="info">
                            <div className="icon">
                                <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479852687-ibq55f-compressed-Frame%201000009055.jpg"/>
                            </div>
                            <p className="title">{t('1_title_h5')}</p>
                             <p className="subtitle">{t('1_subtitle_h5')}</p>
                             <p className="desc">{t('1_desc_h5')}</p>
                             <p className="tip">{t('1_tip')}</p>
                            <div className="charging-speed">
                            {speeds.map((i, idx) => (
                                <div className="charging-speed-item" key={idx}>
                                    <div className="charging-name">{i.name}</div>
                                    <div className="charging-bar">
                                        <div className="charging-bar-inner" style={{ width: chargingBar ? i.width : 0, background: i.color }}></div>
                                    </div>
                                    <div className="charging-minutes">{i.minutes}</div>
                                </div>
                            ))}
                        </div>
                           
                        </div>
                        <div className="video">
                            {load && (
                                <video
                                    src="https://websiteoss.ecoflow.com/upload/video/1762847696496/f1.mp4"
                                    muted
                                    autoPlay
                                    loop
                                    width="100%"
                                    height="100%"
                                    playsInline
                                    poster=""
                                    preload="auto"
                                />
                            )}
                        </div>
                    </div>
                    <div className="card card2">
                        <div className="info">
                            <div className="icon">
                                <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479852687-ibq55f-compressed-Frame%201000009055.jpg" />
                            </div>
                            <p className="title">{t('2_title_h5')}</p>
                            <p className="subtitle">{t('2_subtitle_h5')}</p>
                            <p className="desc">{t('2_desc_h5')}</p>
                        </div>
                        <div className="video">
                            {load && (
                                <video
                                    src="https://websiteoss.ecoflow.com/upload/video/1762847696803/f2.mp4"
                                    muted
                                    autoPlay
                                    loop
                                    width="100%"
                                    height="100%"
                                    playsInline
                                    poster=""
                                    preload="auto"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default F;
